import React, { useContext } from "react";
import styles from "./Menu.module.scss";
import { ReactComponent as Close } from "../../assets/round-close-24px.svg";
import { ThemeContext } from "../../../Context/ThemeContext";
import { Context as LanguageContext } from "../../../Context/LanguageContext";
import { FormattedMessage, injectIntl } from "react-intl";

const Menu = ({
  intl,
  showMenu,
  showProfile,
  handleLoginOperation,
  auth,
  theme,
  thirdPartyAuthenticated,
}) => {
  const languageContext = useContext(LanguageContext);
  const themeContext = useContext(ThemeContext);

  const close = () => {
    showMenu();
  };

  const showProfileHandler = () => {
    close();
    showProfile();
  };

  const login = () => {
    handleLoginOperation();
  };

  const isMobileMenuEnabled =
    theme?.isMobileMenuEnabled ?? themeContext?.theme?.isMobileMenuEnabled;

  return (
    <div
      id="menu"
      className={styles["Modal"]}
    >
      <div
        className={styles["content"]}
        role="dialog"
      >
        <div className={styles["header"]}>
          <div className={styles["button-container"]}>
            <button
              type="button"
              className={styles["button"]}
              onClick={close}
            >
              <Close
                className={styles["Close"]}
                alt="Close menu"
              />
            </button>
          </div>
          {!isMobileMenuEnabled && (
            <>
              <div className={styles["title-container"]}>
                <div className={styles["title"]}>
                  <span>Menu</span>
                </div>
              </div>
              <div className={styles["action-container"]}>
                <div className={styles["action"]} />
              </div>
            </>
          )}
        </div>

        {isMobileMenuEnabled && (
          <img
            height={50}
            style={{
              marginTop: "-35px",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              maxWidth: "200px",
            }}
            src={themeContext?.theme?.desktopHeader?.imageUrl}
            alt="Customisable header"
          />
        )}

        {isMobileMenuEnabled ? (
          <div id="menu-authenticated">
            <ul>
              {themeContext?.hideClientElements?.includes(
                "hideTravelProfile"
              ) ? (
                ""
              ) : auth.isAuthenticated() ? (
                <a
                  onClick={showProfileHandler}
                  className={styles["menu-link-text"]}
                >
                  <FormattedMessage id="myTravelProfile" />
                </a>
              ) : (
                <a
                  onClick={login}
                  rel="noopener noreferrer"
                  className={styles["menu-link-text"]}
                >
                  <FormattedMessage id="myTravelProfile" />
                </a>
              )}
              {themeContext?.theme?.mobileMenu.map((link, index) => {
                const nameToRender =
                  link.values &&
                  Array.isArray(link.values) &&
                  link.values.find(
                    (textValue) =>
                      textValue.languageCode === languageContext.locale
                  )?.value;

                return (
                  <span key={link.key || index}>
                    <p>
                      {link.key !== "profile" ? (
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles["menu-link-text"]}
                        >
                          {nameToRender}
                        </a>
                      ) : (
                        ""
                      )}
                    </p>
                  </span>
                );
              })}
            </ul>
          </div>
        ) : !auth.isAuthenticated() ? (
          thirdPartyAuthenticated ? (
            <div id="menu-authenticated">
              <ul>
                <p
                  onClick={showProfileHandler}
                  className={styles["menu-link-text"]}
                >
                  <FormattedMessage id="myTravelProfile" />
                </p>
                <p>
                  <a
                    href="https://yousmartthing.com/uk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["menu-link-text"]}
                  >
                    About
                  </a>
                </p>
                <p>
                  <a
                    href="https://yousmartthing.atlassian.net/servicedesk/customer/portals"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["menu-link-text"]}
                  >
                    <FormattedMessage id="menuHelp" />
                  </a>
                </p>
              </ul>
            </div>
          ) : (
            <div id="menu-open">
              <ul>
                <p
                  onClick={login}
                  className={styles["menu-link-text"]}
                >
                  <FormattedMessage id="menuSignIn" />
                </p>
                <p>
                  <a
                    href="https://yousmartthing.com/uk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["menu-link-text"]}
                  >
                    <FormattedMessage id="menuAbout" />
                  </a>
                </p>
                <p>
                  <a
                    href="https://yousmartthing.atlassian.net/servicedesk/customer/portals"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["menu-link-text"]}
                  >
                    <FormattedMessage id="menuHelp" />
                  </a>
                </p>
              </ul>
            </div>
          )
        ) : (
          <div id="menu-authenticated">
            <ul>
              <p
                onClick={showProfileHandler}
                className={styles["menu-link-text"]}
              >
                <FormattedMessage id="myTravelProfile" />
              </p>
              <p>
                <a
                  href="/uk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["menu-link-text"]}
                >
                  About
                </a>
              </p>
              <p>
                <a
                  href="https://yousmartthing.atlassian.net/servicedesk/customer/portals"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["menu-link-text"]}
                >
                  Help
                </a>
              </p>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default injectIntl(Menu);
